import { isTaskRemoved } from './taskFilters';

export const formatTaskStatus = (status, t) => {
  const keyMap = {
    draft: 'statusDraft',
    pending: 'statusPending',
    assigned: 'statusAssigned',
    in_progress: 'statusInProgress',
    completed: 'statusCompleted',
    cancelled: 'statusCancelled',
    removed: 'statusRemoved'
  };
  const key = keyMap[status];
  return key ? t(`tasks:${key}`) : status;
};

export const formatTaskDisplayStatus = (task, t, { treatDraft = false } = {}) => {
  if (isTaskRemoved(task)) {
    return formatTaskStatus('removed', t);
  }
  const status = treatDraft && task?.status === 'draft' ? 'draft' : task?.status;
  return formatTaskStatus(status, t);
};

export const formatTaskPriority = (priority, t) => {
  const keyMap = {
    low: 'priorityLow',
    medium: 'priorityMedium',
    high: 'priorityHigh'
  };
  const key = keyMap[priority];
  return key ? t(`tasks:${key}`) : priority;
};
